module.exports = __webpack_public_path__ + "img/consume.5a1d2f81.svg";